import DeletePage from './DeletePage.container';

export default DeletePage;
